import { Box } from "@mui/material";

export default function LoadingScreen() {
  return <Box>Loading...</Box>;
}
